
import { defineComponent } from "vue";
import Quiz from "./components/Quiz.vue";
import { NConfigProvider, GlobalThemeOverrides } from "naive-ui";

const themeOverrides: GlobalThemeOverrides = {
  Button: {
    colorPrimary: "#85B0B2",
    colorHoverPrimary: "#85B0B2cc",
    colorFocusPrimary: "#85B0B2FF",
    colorDisabledPrimary: "#85B0B29E",
    colorPressedPrimary: "##85B0B2cc",
    borderPrimary: "#85B0B2",
    borderHoverPrimary: "#85B0B2",
    borderRadiusMedium: "2rem"

  },
  Card: {
    color: "#000",
    textColor: "#fff",
  },
  Input: {
    borderFocus: "#000",
    borderHover: "#000",
    boxShadowFocus: "0 0 2px #000",
  },
  Checkbox: {
    borderChecked: "1px solid #000",
    colorChecked: "#000",
    borderFocus: "1px solid #000",
    boxShadowFocus: "0 0 2px #000",
  },
  Radio: {
    buttonBorderColor: "1px solid #000",
    dotColorActive: "#000",
    buttonBorderColorActive: "#000",
    buttonBorderColorHover: "#000",
    buttonBoxShadowFocus: "0 0 2px #000",
    boxShadow: "0 0 2px #000",
    boxShadowActive: "0 0 2px #000",
    boxShadowFocus: "0 0 2px #000",
    boxShadowHover: "0 0 2px #000",
    buttonTextColorHover: "#000",
  },
  Spin: {
    color: "#01a9ac",
  },
};

export default defineComponent({
  name: "App",
  components: {
    NConfigProvider,
    Quiz,
  },
  data() {
    return {
      themeOverrides,
    };
  },
});
